// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
// import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors"; // Starter Custom Code
import { chain, LoadRealTimePrices } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { dispatchProductDetailEvent } from "@store/Framework/Services/AnalyticsService";

// Starter Custom Code - >
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
// <--- Starter Custom Code

replaceInChain(chain, LoadRealTimePrices, async props => {
    if (!props.product || !props.productInfosById) {
        return;
    }

    const productIds = Object.keys(props.productInfosById);
    const productPriceParameters = productIds.map(productId => {
        const productInfo = props.productInfosById![productId];
        return {
            productId: productInfo!.productId,
            unitOfMeasure: productInfo!.unitOfMeasure,
            qtyOrdered: productInfo!.qtyOrdered,
        };
    });

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters,
            onComplete: pricingProps => {
                // Starter Custom Code - >
                if (!props.product?.isVariantParent) {
                    dispatchProductDetailEvent(props.product, pricingProps.apiResult?.realTimePricingResults);
                }
                // <-- Starter Custom Code
                if (pricingProps.apiResult?.realTimePricingResults) {
                    const pricing = pricingProps.apiResult.realTimePricingResults!.find(
                        o => o.productId === props.product?.id,
                    );
                    if (pricing) {
                        props.dispatch({
                            type: "Pages/ProductDetails/CompleteLoadRealTimePricings",
                            pricings: pricingProps.apiResult.realTimePricingResults,
                        });
                    } else {
                        props.dispatch({
                            type: "Pages/ProductDetails/FailedLoadRealTimePricings",
                            productIds,
                        });
                    }
                } else if (pricingProps.error) {
                    props.dispatch({
                        type: "Pages/ProductDetails/FailedLoadRealTimePricings",
                        productIds,
                    });
                }

                props.pricingLoaded = true;
            },
        }),
    );

    if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.pricingLoaded);
    }
});
